import React, { useEffect, useState } from "react";
import styles from "./../Loading/Loading.module.css";

const FetchWithToken = async (url, options = {}, body, setLoading) => {
  // دریافت توکن
  const token = localStorage.getItem("token");
  const headers = {
    ...options.headers,
    apikey: token ? `Bearer ${token}` : "",
  };

  try {
    // نمایش لودینگ
    setLoading(true);

    // ارسال درخواست
    const response = await fetch(url, { ...options, headers, body });

    // پنهان کردن لودینگ
    setLoading(false);
    const contentType = response.headers.get("Content-Type");

    if (contentType && contentType.includes("application/octet-stream")) {
      // اگر پاسخ یک فایل است
      return await response.blob(); // تبدیل پاسخ به Blob
    }

    return await response.json();
  } catch (error) {
    // پنهان کردن لودینگ در صورت خطا
    setLoading(false);
    throw error;
  }
};

export const useFetchWithToken = () => {
  const [loading, setLoading] = useState(false);

  return {
    loading,
    fetchWithToken: (url, options, body) =>
      FetchWithToken(url, options, body, setLoading),
  };
};
